// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3164) return "css/3164.67abf2726a9c53e1.css";
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5015":"a51c32251b513f81","5261":"c730db16cc6ce76d","6112":"4b5690efd8dc7175","7127":"7bcedc1b09688c2a"}[chunkId] + ".css";
};